module.exports = __webpack_public_path__ + "img/valvula_borboleta.3fe6ac6a.jpg";